/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface DriverRegistrationDocumentsSetItem {
    field_name: string;
    field_title: string;
    field_description: string;
    is_required: 0 | 1;
    is_expiry_required: 0 | 1;
    document_id: number | null;
    document_name: string | null;
    document_expires: number | null;
}
